export const chartBlue = '#2E8DED';
export const chartGreen = '#3FB23F';
